import { API_URL, itemPerPage } from '../constants/index.js';
import {
    DINING,
    DINING_SUCCESS,
    DINING_ERROR,
    ADD_DINING,
    ADD_DINING_SUCCESS,
    ADD_DINING_ERROR,
    UPDATE_DINING,
    UPDATE_DINING_SUCCESS,
    UPDATE_DINING_ERROR,
    DELETE_DINING,
    DELETE_DINING_ERROR,
    DELETE_DINING_SUCCESS,
    ADD_DINING_IMAGE,
    ADD_DINING_IMAGE_ERROR,
    ADD_DINING_IMAGE_SUCCESS,
    GET_DINING_IMAGES,
    GET_DINING_IMAGES_SUCCESS,
    GET_DINING_IMAGES_ERROR,
    GET_WEEK_DININGS,
    GET_WEEK_DININGS_ERROR,
    GET_WEEK_DININGS_SUCCESS,
    DINING_TAGS,
    DINING_TAGS_SUCCESS,
    DINING_TAGS_ERROR,
    DINING_FILTERS,
    DINING_FILTERS_SUCCESS,
    DINING_FILTERS_ERROR,
    BATCH_DELETE_DINING_SUCCESS,
    DELETE_ALL_DINING_SUCCESS
} from '../constants/diningConstants';
import { sweetAlert } from '../components/Alert/sweetAlert.jsx';

import * as XLSX from 'xlsx';
import moment from 'moment';


//#region GET DINING
export function getDining(data) {
    return {
        type: DINING,
        data
    }
};

export function getDiningSuccess(data, communityId) {
    return {
        type: DINING_SUCCESS,
        data,
        communityId: communityId,
    }
};

export function getDiningError(data) {
    return {
        type: DINING_ERROR,
        data
    }
};

export function GetAllDinings(idCommunity, currentPage) {
    return dispatch => {
        dispatch(getDining());

        fetch(API_URL + `cms/dinings/dinings?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity,
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDiningSuccess(res, idCommunity));
                return res;
            })
            .catch(error => {
                dispatch(getDiningError(error));

            })
    }
};


export function GetDiningDDining(idDining, idCommunity) {
    return dispatch => {
        dispatch(getDining());

        return fetch(API_URL + 'dinings/dinings/' + idDining,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(res => res.json())
            .catch(error => {
                dispatch(getDiningError(error));

            })
    }
}

//#endregion

//#region  Add Dining
export function addDining(data) {
    return {
        type: ADD_DINING,
        data
    }
};

export function addDiningSuccess(data) {
    return {
        type: ADD_DINING_SUCCESS,
        data
    }
};

export function addDiningError(data) {
    return {
        type: ADD_DINING_ERROR,
        data
    }
};

export function AddDining(data, idCommunity) {
    return dispatch => {
        dispatch(addDining());

        fetch(API_URL + 'dinings/dinings',
            {
                body: JSON.stringify(data),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(res => res.json())
            .then(res => {
                const message = `This meal has been added successfully`

                dispatch(addDiningSuccess(res));

                sweetAlert('success', message, 'alert_AddDining_Success');

                return res;
            })
            .catch(error => {
                const message = `An error ocurred when adding the meal`;

                dispatch(addDiningError(error));

                sweetAlert('error', message, 'alert_AddDining_Error');
            })
    }
};
//#endregion

//#region  Update Dining
export function updDining(data) {
    return {
        type: UPDATE_DINING,
        data
    }
};

export function updDiningSuccess(data) {
    return {
        type: UPDATE_DINING_SUCCESS,
        data
    }
};

export function updDiningError(data) {
    return {
        type: UPDATE_DINING_ERROR,
        data
    }
};

export function UpdDining(idDining, data, idCommunity) {
    return dispatch => {
        dispatch(updDining());

        fetch(API_URL + 'dinings/dinings/' + idDining,
            {
                body: JSON.stringify(data),
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity,
                }
            })
            .then(res => {
                const message = `This meal has been updated successfully`

                dispatch(updDiningSuccess(data));

                sweetAlert('success', message, 'alert_UpdateDining_Success');
                return res;
            })
            .catch(error => {
                const message = `An error has occurred while updating the meal`

                dispatch(updDiningError(error));

                sweetAlert('error', message, 'alert_UpdateDining_Error');

            })
    }
};
//#endregion

//#region  Delete Dining
export function delDining(data) {
    return {
        type: DELETE_DINING,
        data
    }
};

export function delDiningSuccess(data) {
    return {
        type: DELETE_DINING_SUCCESS,
        data
    }
};

export function delDiningError(data) {
    return {
        type: DELETE_DINING_ERROR,
        data
    }
};

export function DelDining(diningId) {
    return dispatch => {
        dispatch(delDining());

        fetch(API_URL + '/dinings/dining/' + diningId,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(res => {
                const message = `This meal has been deleted successfully`

                dispatch(delDiningSuccess(diningId));

                sweetAlert('success', message, 'alert_DeleteDining_Success');
                return res;
            })
            .catch(error => {
                const message = `An error has occurred while deleting the meal`

                dispatch(delDiningError(error));

                sweetAlert('error', message, 'alert_DeleteDining_Error');
            })
    }
};
//#endregion

//#region  Delete Dining
export function deleteRecurrencyMeals(data) {
    return {
        type: DELETE_DINING,
        data
    }
};

export function deleteRecurrencyMealsSuccess(data) {
    return {
        type: DELETE_DINING_SUCCESS,
        data
    }
};

export function deleteRecurrencyMealsError(data) {
    return {
        type: DELETE_DINING_ERROR,
        data
    }
};

export function DeleteRecurrencyMeals(diningId) {
    return dispatch => {
        dispatch(delDining());

        fetch(API_URL + '/dinings/diningRecurrence/' + diningId,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(res => {
                const message = `This meal has been deleted successfully`

                dispatch(delDiningSuccess(diningId));

                sweetAlert('success', message, 'alert_DeleteRecurrenceDining_Success');
                return res;
            })
            .catch(error => {
                const message = `An error has occurred while updating the meal`

                dispatch(delDiningError(error));

                sweetAlert('error', message, 'alert_DeleteRecurrenceDining_Error');
            })
    }
};
//#endregion


export function batchDelDiningSuccess(data) {
    return {
        type: BATCH_DELETE_DINING_SUCCESS,
        data
    }
};

export function BatchDeleteDining(dinings) {
    return dispatch => {
        dispatch(delDining());

        fetch(API_URL + '/dinings/dinings/',
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'dinings': dinings.join(',')
                }
            })
            .then(res => {
                const message = `The meals has been deleted successfully`

                dispatch(batchDelDiningSuccess(dinings));

                sweetAlert('success', message, 'alert_DeleteDining_Success');
                return res;
            })
            .catch(error => {
                const message = `An error has occurred while deleting the meals`

                dispatch(delDiningError(error));

                sweetAlert('error', message, 'alert_DeleteDining_Error');
            })
    }
};

//#region ADD Image  Used in both Detail and Thumbnail Image
export function addDiningImage(data) {
    return {
        type: ADD_DINING_IMAGE,
        data
    }
};

export function addDiningImageSuccess(data) {
    return {
        type: ADD_DINING_IMAGE_SUCCESS,
        data
    }
};

export function addDiningImageError(data) {
    return {
        type: ADD_DINING_IMAGE_ERROR,
        data
    }
};

export function AddDiningImage(data, idCommunity) {
    return dispatch => {
        //dispatch(addDiningImage());
        return fetch(API_URL + 'dinings/addImage',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(res => { const resJson = res.json(); return resJson; })
            .then(res => {
                //dispatch(addDDiningImageSuccess(res));
                return res;
            })
            .catch(error => {
                //dispatch(addDDiningImageError(error));

            })
    }
};



//#endregion

//#region default dining images

export function getImages(data) {
    return {
        type: GET_DINING_IMAGES,
        data
    }
};

export function getImagesSuccess(data) {
    return {
        type: GET_DINING_IMAGES_SUCCESS,
        data
    }
};

export function getImagesError(data) {
    return {
        type: GET_DINING_IMAGES_ERROR,
        data
    }
};

export function GetDiningImages(idCommunity) {
    return dispatch => {
        dispatch(getImages());

        fetch(API_URL + 'dinings/images/' + idCommunity,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getImagesSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getImagesError(error));

            })
    }
};


export function getWeekDining(data) {
    return {
        type: GET_WEEK_DININGS,
        data
    }
};

export function getWeekDiningSuccess(data) {
    return {
        type: GET_WEEK_DININGS_SUCCESS,
        data
    }
};

export function getWeekDiningError(data) {
    return {
        type: GET_WEEK_DININGS_ERROR,
        data
    }
};

export function GetWeeklyDinings(idCommunity) {

    return async dispatch => {
        try {
            dispatch(getWeekDining());

            const res = await fetch(API_URL + 'dinings/week/' + idCommunity,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                });


            const data = await res.json();

            if (res.status === 200) {

                dispatch(getWeekDiningSuccess(data));
                return data;

            } else {
                dispatch(getWeekDiningError(res.body));
            }


        } catch (err) {
            dispatch(getWeekDiningError(err));
        }
    }
};


export function GetDiningsForCSVExport(idCommunity, communityName) {
    return async dispatch => {
        try {
            const newCommunityName = communityName ? communityName.split(' ').filter(a => a.length > 0).map(a => a.trim()).join('_') : '';

            dispatch(getWeekDining());

            const res = await fetch(API_URL + 'dinings/week/' + idCommunity,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                });

            if (!res || res.status !== 200) {
                dispatch(getWeekDiningError(res.body));

                return;
            }
            const data = await res.json();

            dispatch(getWeekDiningSuccess(data));

            //Menu 
            const MealsMenu = ExportMealsToCSV(data)
            const Document1 = XLSX.utils.book_new();
            const MealsMenuSheet = XLSX.utils.aoa_to_sheet(MealsMenu);
            XLSX.utils.book_append_sheet(Document1, MealsMenuSheet, "meals");
            const fileName1 = `Meals_Data_${newCommunityName}_${idCommunity}.csv`
            XLSX.writeFile(Document1, fileName1);

            // Recurrence data
            const MealsRecurrence = ExportRecurrenceData(data)
            const Document2 = XLSX.utils.book_new();
            const MealsRecurrenceSheet = XLSX.utils.aoa_to_sheet(MealsRecurrence);
            XLSX.utils.book_append_sheet(Document2, MealsRecurrenceSheet, "meals");
            const fileName2 = `Meals_Recurrence_${newCommunityName}_${idCommunity}.csv`
            XLSX.writeFile(Document2, fileName2);

            // Images
            const MealsImages = ExportImagesURL(data)
            const Document3 = XLSX.utils.book_new();
            const MealsImagesSheet = XLSX.utils.aoa_to_sheet(MealsImages);
            XLSX.utils.book_append_sheet(Document3, MealsImagesSheet, "meals");
            const fileName3 = `Meals_Pictures_${newCommunityName}_${idCommunity}.csv`
            XLSX.writeFile(Document3, fileName3);

            return data;


        } catch (err) {
            dispatch(getWeekDiningError(err));
        }
    }
};


//#endregion


//#region GET DINING TAGS
export function getTags(data) {
    return {
        type: DINING_TAGS,
        data
    }
};

export function getTagsSuccess(data, communityId, currentPage) {
    return {
        type: DINING_TAGS_SUCCESS,
        data,
    }
};

export function getTagsError(data) {
    return {
        type: DINING_TAGS_ERROR,
        data
    }
};

export function GetDiningTags(idCommunity, dateChanged, dateOption, startDate, endDate) {
    return dispatch => {
        dispatch(getTags());

        const headers = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'CommunityId': idCommunity,
        }

        if (dateOption) {
            headers.date_option = dateOption
        } else if (dateChanged && startDate && endDate) {
            headers.start_date = startDate
            headers.end_date = endDate
        }

        return fetch(API_URL + `dinings/tags`,
            {
                method: 'GET',
                headers: headers
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getTagsSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getTagsError(error));
            })
    }
};


export function getDiningFilters(data) {
    return {
        type: DINING_FILTERS,
        data
    }
};

export function getDiningFiltersSuccess(data, communityId, currentPage) {
    return {
        type: DINING_FILTERS_SUCCESS,
        data,
        communityId: communityId,
        currentPage: currentPage,
    }
};

export function getDiningFiltersError(data) {
    return {
        type: DINING_FILTERS_ERROR,
        data
    }
};

const getHeaders = (filters, idCommunity, search, sort, direction) => {
    const headers = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'CommunityId': idCommunity,
        'custom_sort': sort ? sort : 'dateStart',
        'sort_dir': direction === true ? 1 : -1

    }

    if (filters.dateOptionSelected) {

        headers.date_option = filters.dateOptionSelected

    } else if (filters.dateChanged && !filters.dateOptionSelected) {
        headers.start_date = filters.startDate
        headers.end_date = filters.endDate
    }

    if (filters.mealsSelected && filters.mealsSelected.length > 0) {
        headers.meal_types = filters.mealsSelected.join(',')
    }

    if (filters.tagsSelected && filters.tagsSelected.length > 0) {
        headers.tags = filters.tagsSelected.join(',')
    }

    //Searching
    if (search && search !== '') {
        headers.search = search;
    }

    return headers;

}

export function GetDiningFilters(idCommunity, currentPage, filters, search, sort, direction) {
    return dispatch => {
        dispatch(getDiningFilters());

        const headers = getHeaders(filters, idCommunity, search, sort, direction);

        return fetch(API_URL + `dinings/filters?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: headers
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDiningFiltersSuccess(res, idCommunity, currentPage));
            })
            .catch(error => {
                dispatch(getDiningFiltersError(error));
            })
    }
};

export function deleteAllSuccess(data) {
    return {
        type: DELETE_ALL_DINING_SUCCESS,
        data
    }
};

export function DeleteAllDinings(idCommunity, filters, search) {
    return dispatch => {
        dispatch(delDining());

        const headers = getHeaders(filters, idCommunity, search);

        fetch(API_URL + '/dinings/dinings/all',
            {
                method: 'DELETE',
                headers: headers
            })
            .then(res => {
                const message = `The meals has been deleted successfully`

                dispatch(deleteAllSuccess());

                sweetAlert('success', message, 'alert_DeleteDining_Success');
                return res;
            })
            .catch(error => {
                const message = `An error has occurred while deleting the meals`

                dispatch(delDiningError(error));

                sweetAlert('error', message, 'alert_DeleteDining_Error');
            })
    }
};

const getDiningType = (type) => {
    switch (type) {
        case 1:
            return "Breakfast";
        case 2:
            return "Lunch";
        case 3:
            return "Dinner";
        default:
            return "";
    }
};

const ExportMealsToCSV = (data) => {

    if (!data || data.length <= 0) {
        return [
            [`No data found`]
        ];
    }

    //Filter the dinings to have just the first recurrence 
    const dataFiltered = []

    data.forEach(d => {
        //Search for a meal with the same recurrency Id
        const existRecurrence = dataFiltered.find(x => x._id === d.recurrencyId || (x.recurrencyId && x.recurrencyId === d.recurrencyId))

        //If I dont find an element with that recurrence id I insert the element into the array
        if (!existRecurrence) {
            dataFiltered.push(d)
        }
    })

    dataFiltered.sort(function (a, b) {
        let x = a.dateStart;
        let y = b.dateStart;
        if (x < y) { return -1; }
        if (x > y) { return 1; }
        return 0;
    });


    //Separate the data by meal types
    const mealsTimes = [
        dataFiltered.filter(d => d.type === 1),
        dataFiltered.filter(d => d.type === 2),
        dataFiltered.filter(d => d.type === 3)
    ]

    let fullData = [
        [' ', ' '],// The first row has the name, day and description
        [' ', ' ']// Second row with the date in format yyyy/mmm/dd
    ]

    //Firts I need to create the headers

    let dateStart = moment(dataFiltered[0].dateStart).startOf('week').format('YYYY-MM-DD'); //Get the date of the first element in the array sorted by date, this is static

    let currentDate = moment(dataFiltered[0].dateStart).startOf('week').format('YYYY-MM-DD'); //Get the first date of the element in the array
    let lastDay = moment(dataFiltered[dataFiltered.length - 1].dateStart).format('YYYY-MM-DD')//The last day will be the date of the last element of the array

    while (currentDate <= lastDay) {

        const d = moment(currentDate);
        fullData[0].push(d.format('dddd'));
        fullData[0].push('Description')

        fullData[1].push(d.format('DD-MMM-YY'));
        fullData[1].push(' ')

        mealsTimes.forEach(m => { // For each meal time there will be a few rows depending the number of meals per day

            let mealsForToday = m.filter(x => moment(x.dateStart) === d); //Filter my meals to know wich ones are for today

            mealsForToday.forEach((meal, index) => { //For each meal for today im going to create a row or insert the values in an existing row

                //Search the row by meal time
                const indexOfMealType = fullData.findIndex(i => i[0] === getDiningType(meal.type))//Find the row that i need
                const diff = Math.round((new Date(d.format('YYYY-MM-DD')).getTime() - new Date(dateStart).getTime()) / (1000 * 60 * 60 * 24)); //Here I get the position in which i should place the data according to the date

                if (indexOfMealType !== -1 && index <= 0) { //If I found the row and is the first index I insert the data

                    fullData[indexOfMealType][(diff * 2) + 2] = meal.name
                    fullData[indexOfMealType][(diff * 2) + 3] = meal.description

                } else { //If I don't find the row or is the meal number 2 or 3 I create the row

                    const row = [getDiningType(meal.type), "Accompaniment"]

                    //+2 because I get the difference in days but we need to consider the extra 2 positions at the beggining of the rows
                    row[(diff * 2) + 2] = meal.name;
                    row[(diff * 2) + 3] = meal.description;

                    fullData.push(row);
                }
            })

        });

        currentDate = d.add(1, 'day').format('YYYY-MM-DD');
    }


    //we need to fill the the rows to all have the same lenght because CL says so
    const maxLenght = fullData
        .map(a => a.length)
        .indexOf(Math.max(...fullData.map(a => a.length)));

    fullData.forEach(a => {
        if (a.length < fullData[maxLenght].length) {
            for (let index = a.length; index < fullData[maxLenght].length; index++) {
                a.push('')
            }
        }
    });

    return fullData;
}

const ExportRecurrenceData = (data) => {

    if (!data || data.length <= 0) {
        return [
            [`No data found`]
        ];
    }

    //Filter the dinings to have just the first recurrence 
    const dataFiltered = []

    data.forEach(d => {
        //Search for a meal with the same recurrency Id
        const existRecurrence = dataFiltered.find(x => x._id === d.recurrencyId || (x.recurrencyId && x.recurrencyId === d.recurrencyId))

        //If I don't find an element with that recurrence id I insert it into the array
        //I also check that it has recurrence
        if (!existRecurrence && d.recurrencyData && d.recurrencyData.endDateForRecurrency) {
            dataFiltered.push(d)
        }
    });

    const document = [
        ['Meal title', 'Description', 'Meal type', 'Date', 'Is Recurring', 'Recur until', 'Recur Ocurrences', 'Recurring Interval', 'Frequency', 'Frecuency Repeat', 'Label']
    ];

    dataFiltered.forEach(d => {

        const newRow = [
            d.name,
            d.description,
            getDiningType(d.type),
            moment(d.dateStart).format('MM/DD/YYYY'),
            "Y",
            moment(d.recurrencyData.endDateForRecurrency).format('MM/DD/YYYY'),
            d.recurrencyData.customEndOption.name === 'After' ? d.recurrencyData.customEndOcurrences : "",
            d.recurrencyData.customRepeatInterval,
            d.recurrencyData.customRepeatValue,
            d.recurrencyData.customRepeatValue === 'Weekly' ? d.recurrencyData.weeklyRecurrence.map(x => (x.name)).toString() : '',
            d.recurrencyData.OccurrenceLabel
        ]


        document.push(newRow);


    });

    return document;


}

const ExportImagesURL = (data) => {
    if (!data || data.length <= 0) {
        return [
            [`No data found`]
        ];
    }

    const fullData = [
        ['Date', 'Meal name', 'ImageUrl']
    ];

    //Filter my data to have to not have duplicated images
    data = data.filter((value, index, self) =>
        index === self.findIndex((t) => (
            value.imageUrl && t.imageUrl === value.imageUrl
        )))

    data.forEach(m => {
        const row = [moment(m.dateStart).format('DD-MMM-YYYY'), m.name, m.imageUrl]

        fullData.push(row);
    })

    return fullData;

}
